import LiveShoppingOverview from '@aboutyou/legacy-shared/src/pages/Live/LiveShopping/LiveShoppingOverviewPage'
import LiveShoppingTranslationContext, {
  LiveShoppingTranslations,
} from '@aboutyou/legacy-shared/src/pages/Live/context/TranslationProvider'
import { LoadingContainer } from 'components/Loading'
import { useTranslation } from 'helpers/hooks/useTranslation'
import { useTrackingCustomer } from '@aboutyou/legacy-shared'
import { useObserver } from 'mobx-react-lite'
import * as React from 'react'
import { useMemo } from 'react'
import {
  useLiveShoppingStore,
  useLocaleStore,
  useUserStore,
} from 'store/context'
import styled from 'styled-components'
import DocumentHead from './components/DocumentHead'

const LiveShoppingOverviewContainer = styled.div``

function useLiveShoppingOverviewPage() {
  const { gender } = useUserStore()
  const liveShopping = useLiveShoppingStore()

  return useObserver(() => ({
    liveShoppingOverview: liveShopping.liveShoppingDateByGender[gender],
    isLoading: liveShopping.isLoading,
  }))
}

const useLiveShoppingTranslations = (): LiveShoppingTranslations => {
  const { locale } = useLocaleStore()
  const { t } = useTranslation()
  return useMemo(
    () => ({
      liveShopping: t('Live Shopping'),
      liveAndUpcomingShows: t('Live & Upcoming Shows'),
      current: t('aktuell'),
      passed: t('abgelaufen'),
      liveNow: t('Jetzt Live'),
      today: t('Heute'),
      toTheShow: t('Zur Show'),
      toTheLiveShow: t('Zur Live Show'),
      tomorrow: t('Morgen'),
      seo: {
        title: t('Live Shopping Events | Trends & Produkte | ABOUT YOU'),
        description: t(
          'Bei den Live Shopping Events auf ABOUT YOU werden dir neue Modetrends und Produkte live vorgestellt und sind direkt im Shop erhältlich',
        ),
      },
      locale,
    }),
    [locale, t],
  )
}

function LiveShoppingOverviewPage() {
  const { liveShoppingOverview, isLoading } = useLiveShoppingOverviewPage()
  const translations = useLiveShoppingTranslations()
  const trackingCustomer = useTrackingCustomer()

  if (isLoading || !liveShoppingOverview) {
    return <LoadingContainer />
  }

  return (
    <>
      <DocumentHead {...translations.seo} customTitleTemplate />
      <LiveShoppingOverviewContainer>
        <LiveShoppingTranslationContext.Provider value={translations}>
          <LiveShoppingOverview
            liveShoppingOverviewPage={liveShoppingOverview}
            trackingCustomer={trackingCustomer}
          />
        </LiveShoppingTranslationContext.Provider>
      </LiveShoppingOverviewContainer>
    </>
  )
}

const Component = LiveShoppingOverviewPage

export default Component
